import { render } from "./AppRedirect.vue?vue&type=template&id=fa3a3ccc"
import script from "./AppRedirect.vue?vue&type=script&lang=js"
export * from "./AppRedirect.vue?vue&type=script&lang=js"

import exportComponent from "/home/dijuno-mobile/dijuno-mobile.pderasapps.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__